import { createSlice } from "@reduxjs/toolkit";
import { addGenre, editGenre, getGenre, getGenreList } from "../services/genre-services";

const initialState = {
  genres: [],
  genre: null,
  pagination: null,
  error: [],
  loading: false,
  responseMessage: null,
  success: false,
  successMessage: null,
  deleteResponse: false,
  errorMessage: null,
};

export const genreSlice = createSlice({
  name: "genre",
  initialState,
  reducers: {
    resetError(state) {
      state.errorMessage = null;
    },

    resetSuccess(state) {
      state.successMessage = null;
    },

    resetState(state) {
      state.success = false;

    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGenreList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getGenreList.fulfilled, (state, action) => {
        state.genres = action.payload.data.items;
        state.pagination = action.payload.data.item;
        state.currentPage = action.payload.data.item;
        state.loading = false;
      })
      .addCase(getGenreList.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getGenre.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getGenre.fulfilled, (state, action) => {
        state.genres = action.payload.data.item;
        state.pagination = action.payload.data.item;
        state.loading = false;
      })
      .addCase(getGenre.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(addGenre.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(addGenre.fulfilled, (state, action) => {
        state.genres = action.payload;
        state.successMessage = action.payload.message;
        state.loading = false;
        state.success = true;
      })
      .addCase(addGenre.rejected, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.errorMessage = action.payload;
        } else {
          state.errorMessage = "Something went wrong";
        }
      })
      .addCase(editGenre.pending, (state, action) => {
        state.loading = false;
      })
      .addCase(editGenre.fulfilled, (state, action) => {
        state.genres = action.payload;
        state.successMessage = action.payload.message;
        state.loading = false;
        state.success = true;
      })
      .addCase(editGenre.rejected, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.errorMessage = action.payload;
        } else {
          state.errorMessage = "Something went wrong";
        }
      })
      
  },
});
export const { resetSuccess, resetState, resetError } = genreSlice.actions;
export const error = (state) => state.error;
export const loading = (state) => state.loading;
export const deleteResponse = (state) => state.deleteResponse;
export default genreSlice.reducer;
